import type { ReactElement } from "react";
import type { ColorValue } from "react-native";
import { isIconType } from "../../icon";
import MemorangIcons from "../MemorangIcons";
import { AppIcon } from "./index";

type MakeIconProps = {
	size: number;
	color: ColorValue;
	accessibilityLabel?: string;
	accessible?: boolean;
};

export type IconRenderer = (props: MakeIconProps) => ReactElement;

export const makeIcon =
	(name: string, custom?: boolean): IconRenderer =>
	(props: MakeIconProps) =>
		!custom && isIconType(name) ? (
			<AppIcon name={name} {...props} />
		) : (
			<MemorangIcons name={name} {...props} />
		);
